import { render, staticRenderFns } from "./color.vue?vue&type=template&id=065778cb&scoped=true"
import script from "./color.vue?vue&type=script&lang=js"
export * from "./color.vue?vue&type=script&lang=js"
import style0 from "./color.vue?vue&type=style&index=0&id=065778cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065778cb",
  null
  
)

export default component.exports